import { Suspense } from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const Loader = () => {
  return (
    <Box
      sx={{ position: "fixed", top: 0, left: 0, zIndex: 2001, width: "100%" }}
    >
      <LinearProgress color="primary" />
    </Box>
  );
};

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
